import styled from 'styled-components';

export const ConfirmationContainer = styled('div')`
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
`;
